import { Placement, Strategy } from '@floating-ui/core'
import { FlipOptions } from '@floating-ui/dom'
import { FloatingFocusManager } from '@floating-ui/react'
import React, { ReactElement } from 'react'
import usePopoverProperties from './hooks/usePopoverProperties'

export interface PopoverProps {
  offsetValue: number
  flipOptions: FlipOptions
  strategyValue: Strategy
  placement: Placement
  triggerElement: ReactElement
  popoverContent: ReactElement
  ignoredEventTypes?: Event['type'][]
  isOpen?: boolean
  setIsOpen?: (isOpen: boolean) => void
}

const Popover = ({
  offsetValue,
  flipOptions,
  strategyValue,
  placement,
  triggerElement,
  popoverContent,
  ignoredEventTypes = [],
  isOpen,
  setIsOpen,
}: PopoverProps) => {
  const {
    refs,
    floatingStyles,
    getReferenceProps,
    getFloatingProps,
    isOpen: isPopoverOpen,
    context,
  } = usePopoverProperties({
    offsetValue,
    flipOptions,
    strategyValue,
    placement,
    ignoredEventTypes,
    isOpen,
    setIsOpen,
  })

  const triggerElementWithProps = React.cloneElement(triggerElement, {
    ref: refs.setReference,
    ...getReferenceProps({ onClick: e => e.stopPropagation() }),
  })

  return (
    <>
      {triggerElementWithProps}
      {isPopoverOpen && (
        <FloatingFocusManager context={context} modal={false}>
          <div
            ref={refs.setFloating}
            style={{ ...floatingStyles, zIndex: 100 }}
            {...getFloatingProps()}
          >
            {popoverContent}
          </div>
        </FloatingFocusManager>
      )}
    </>
  )
}

export default Popover
